<template>
  <a :href="url" class="pessoa">
    <p class="responsavel_lable" v-if="responsavel">
      {{ $t("responsavel") }}                              
    </p>
    <span class="imagem" :style="imagemStyle" />
    <div class="infopessoa">
      <h5 class="nome">{{ nome }}</h5>
      <h6 class="cargo">{{ email }}</h6>
    </div>
  </a>
</template>

<script>
import avatar from "@/assets/pessoa_avatar-03.png";
import { computed } from "vue"; 

export default {
  props: {
    imagem: {
      type: String,
      default: avatar,
    },
    email: String,
    nome: String,
    url: String,
    responsavel: Boolean
  },
  setup (props) {
    const imagemStyle = computed(() => {
      const imageUrl = props.imagem || avatar; 
      return `background-image: url('${imageUrl}')`;
    });

    return {
      imagemStyle
    }
  }
}
</script>

<style scoped>
.imagem {
  display: block;
  background: black;
  border-radius: 50%;
  height: 80px;
  width: 80px;
  background: #b1b1b1;
  margin: 25px 20px;
  background-size: cover;
  background-position: center;
}

.infopessoa {
  display: flex;
  flex: 2;
  flex-direction: column;
  margin-right: 15px;
  padding-top: 30px;
  padding-bottom: 30px;
  color: #535d61;
}

.pessoa {
  background: #f4f4f4;
  /*height: 100%;*/
  margin-left: 0 !important;
  display: flex;
  flex-direction: row;
  position: relative;
  margin-right: 0;
}

.nome {
  font-family: 'PT Sans';
  line-height: 1.4;
  font-size: 16px;
  margin-bottom: 0;
}

.cargo {
  font-family: 'PT Sans Bold Italic';
  font-size: 16px;
  margin-top: .5rem;
  word-break: break-word;
}


@media (max-width: 1280px) {
  .imagem{
    display: none;
  }

  .infopessoa{
    padding-left: 25px;
    padding-bottom: 30px;
  }

}

@media (min-width : 768px) and (max-width : 1024px){
  .nome {
    font-size: 15px;
  }

  .cargo {
    font-size: 15px;
    margin-top: 2px!important;
  }

}

@media (max-width: 767px){
  .nome, .cargo {
    font-size: 14px;
  }

  .cargo {
    margin-top: 0px;
  }

  .infopessoa {
    padding-top: 18px;
    padding-bottom: 18px;
    padding-left: 25px;
  }

  .pessoa {
    margin-left: 0px !important;
  }

}

.responsavel_lable {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #79b2dc;
  padding-right: 10px;
  padding-left: 12px;
  padding-bottom: 3px;
  padding-top: 3px;
  line-height: 1.4;
  color: white;
  font-size: 12px;
  font-family: Montserrat;
  text-transform: uppercase;
  display: inline-block;
}


</style>